/**
 * "Longhousee là gì / hoạt động thế nào" — phần thông tin chính cho người MỚI:
 * sàn liên kết + 3 bước từ tải app đến rút tiền về ngân hàng.
 */
import React from "react";
import { MERCHANTS, STEPS } from "../download-app-content";

export default function DownloadHowItWorks() {
    return (
        <div className="px-4 mt-7">
            <div className="bg-surface rounded-2xl p-4 border border-line shadow-sm">
                <h2 className="font-bold text-lg text-center md:text-left">Longhousee là gì?</h2>
                <p className="text-sm text-content-2 mt-2 leading-relaxed">
                    Longhousee là ứng dụng <strong>mua sắm hoàn tiền</strong>: bạn vẫn mua hàng trên các sàn quen thuộc với đúng giá đó,
                    nhưng đi qua App để nhận lại một phần tiền vào ví — rồi rút về tài khoản ngân hàng.
                </p>

                {/* Sàn đang liên kết */}
                <div className="grid grid-cols-4 gap-2 mt-4">
                    {MERCHANTS.map((m) => (
                        <div key={m.name} className="flex flex-col items-center gap-1.5 bg-surface-sunken rounded-xl py-3 px-1">
                            <img src={m.logo} alt={m.name} className="w-8 h-8 object-contain" loading="lazy" />
                            <span className="text-[10px] text-content-2 text-center leading-tight">{m.name}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* 3 bước nhận tiền */}
            <h2 className="font-bold text-lg mt-6 mb-3 text-center md:text-left">Nhận tiền hoàn chỉ 3 bước</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {STEPS.map((s, i) => (
                    <div key={s.title} className="flex md:flex-col items-start gap-3 bg-surface rounded-2xl p-4 border border-line shadow-sm">
                        <div className="w-9 h-9 shrink-0 rounded-full bg-gradient-to-br from-[#ff7a45] to-[#ff544f] text-white font-bold flex items-center justify-center">
                            {i + 1}
                        </div>
                        <div>
                            <p className="font-bold text-sm">{s.title}</p>
                            <p className="text-xs text-content-3 mt-1 leading-relaxed">{s.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
